import { toast } from "sonner";
import { BRANDS, PRODUCTS } from "../../data/store";
import { PageTitle, Table, Btn } from "./ui";

export default function AdminBrands() {
  return (
    <div data-testid="admin-brands">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauns zīmols (DEMO)", { description: "Pilnajā versijā atvērtos zīmola forma ar logo augšupielādi." })} data-testid="brand-add">+ Pievienot zīmolu</Btn>}>
        Zīmoli / Ražotāji ({BRANDS.length})
      </PageTitle>
      <Table head={["Zīmols", "Apraksts", "Preces", ""]}>
        {BRANDS.map((b) => {
          const count = PRODUCTS.filter((p) => p.brand.toLowerCase().startsWith(b.name.split(" ")[0].toLowerCase())).length;
          return (
            <tr key={b.slug} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`brand-admin-row-${b.slug}`}>
              <td className="p-3 font-extrabold">{b.name}</td>
              <td className="text-[#6B6B6B] max-w-[400px]">{b.desc}</td>
              <td className="font-bold">{count}</td>
              <td className="p-3"><Btn variant="outline" onClick={() => toast.success("Zīmola kartīte atvērta (DEMO)")} data-testid={`brand-edit-${b.slug}`}>Rediģēt</Btn></td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}
